import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';

const AboutPage = () => {
  return (
    <div className="flex flex-col min-h-screen">
      <Header />
      
      <main className="flex-grow">
        {/* Updated Hero Section - widened */}
        <section className="relative py-10 bg-blue-800">
          <div className="container mx-auto px-4 md:px-8">
            <div className="max-w-6xl mx-auto">
              <h1 className="text-2xl md:text-3xl font-bold text-white">About Us</h1>
              <div className="h-0.5 w-16 bg-white mt-2 mb-4"></div>
              <p className="text-white">
                Commissionerate of Rural Development and Panchayat Raj (Training)
              </p>
            </div>
          </div>
        </section>
        
        {/* Main Content Section - widened with improved spacing */}
        <section className="py-16 bg-white">
          <div className="container mx-auto px-4 md:px-8 lg:px-12">
            <div className="max-w-6xl mx-auto">
              <div className="mb-12">
            
              
                
                <div className="mb-12">
                  <div className="bg-blue-50 border-l-4 border-blue-600 p-6 mb-10">
                    <h3 className="text-2xl font-semibold text-blue-800 mb-4">
                      COMMISSIONERATE OF RURAL DEVELOPMENT AND PANCHAYAT RAJ (Training)
                    </h3>
                    <p className="text-lg text-gray-700">
                      <strong>Rural Development and Panchayat Raj Department, Govt. of Tamil Nadu</strong>
                    </p>
                  </div>
                </div>
                
                <div className="mb-10">
                  <h3 className="text-2xl font-semibold text-blue-800 mb-5 pb-2 border-b border-gray-200">
                    Commissionerate of Rural Development & Panchayat Raj (Training)
                  </h3>
                  <p className="text-gray-700 text-lg leading-relaxed mb-6">
                    The Commissionerate of RD&PR (Training) is undertaking all the planning, implementation and monitoring the capacity building and training activities in the state through SRID&PR and five RIRD&PR. The Commissionerate is headed by a senior officer in the rank of Additional Chief Secretary who is also the Vice-Chairman of SIRD&PR society. An officer in the cadre of Additional Director is in-charge for the training related activities and functioning from State Institue in the State Institute of Rural Development and Panchayat Raj as its Director.
                  </p>
                </div>
                
                <div className="mb-10">
                  <p className="text-gray-700 text-lg leading-relaxed mb-6">
                    Rural Development and Panchayat Raj Department at State level to undertake various capacity building and research activities. SIRD&PR Conceptualize, Design, Organize, Coordinate and Monitor training and Capacity Building of the elected representatives of three tier Panchayat Raj Institutions, Officials of RD&PR and other line departments, CBOs and general Public. The Institute was found in 1990 and registered under Tamil Nadu Societies Registration Act, 1975. Presently the Institute is functioning in a 25 acre campus at Maraimalainagar, near Chennai.
                  </p>
                </div>
                
                <div>
                  <h3 className="text-2xl font-semibold text-blue-800 mb-5 pb-2 border-b border-gray-200">
                    Regional Institutes of Rural Development & Panchayat Raj
                  </h3>
                  <p className="text-gray-700 text-lg leading-relaxed">
                    The Regional Institutes of Rural Development & Panchayat Raj at Sathiya Vijaya Nagaram in Tiruvannamalai district, Krishnagiri in Krishnagiri district, Pattukottai, in Thanjavur district, Bhavanisagar in Erode district and T.Kallupatty in Madurai district are entrusted with the task of imparting training. RIRD & PRs are headed by Principals in the cadre of Additional Director/Joint Director of Rural Development and Panchayat Raj Department.
                  </p>
                </div>
              </div>
              
              {/* Image Gallery Section - wider layout with better spacing */}
              <div className="mt-16">
                <h2 className="text-3xl font-bold text-gray-800 mb-6 text-center">Our Gallery</h2>
                <div className="h-1 w-16 bg-blue-600 mx-auto mb-12"></div>
                
                <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
                  {/* Image 1 */}
                  <div className="overflow-hidden rounded-lg shadow-lg transition-all duration-300 hover:shadow-xl">
                    <img 
                      src="images/about1.png.jpg" 
                      alt="Rural Development" 
                      className="w-full h-64 object-cover transition-transform duration-500 hover:scale-105"
                    />
                  </div>
                  
                  {/* Image 2 */}
                  <div className="overflow-hidden rounded-lg shadow-lg transition-all duration-300 hover:shadow-xl">
                    <img 
                      src="images/about2.png.jpg" 
                      alt="Training Session" 
                      className="w-full h-64 object-cover transition-transform duration-500 hover:scale-105"
                    />
                  </div>
                  
                  {/* Image 3 */}
                  <div className="overflow-hidden rounded-lg shadow-lg transition-all duration-300 hover:shadow-xl">
                    <img 
                      src="images/about3.png.jpg" 
                      alt="SIRD Campus" 
                      className="w-full h-64 object-cover transition-transform duration-500 hover:scale-105"
                    />
                  </div>
                  
                  {/* Image 4 */}
                  <div className="overflow-hidden rounded-lg shadow-lg transition-all duration-300 hover:shadow-xl">
                    <img 
                      src="images/about4.png.jpg" 
                      alt="Panchayat Raj Activities" 
                      className="w-full h-64 object-cover transition-transform duration-500 hover:scale-105"
                    />
                  </div>
                  
                  {/* Image 5 */}
                  <div className="overflow-hidden rounded-lg shadow-lg transition-all duration-300 hover:shadow-xl">
                    <img 
                      src="images/about5.png.jpg" 
                      alt="Infrastructure Development" 
                      className="w-full h-64 object-cover transition-transform duration-500 hover:scale-105"
                    />
                  </div>
                  
                  {/* Image 6 */}
                  <div className="overflow-hidden rounded-lg shadow-lg transition-all duration-300 hover:shadow-xl">
                    <img 
                      src="images/about6.png.jpg" 
                      alt="Rural Communities" 
                      className="w-full h-64 object-cover transition-transform duration-500 hover:scale-105"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        
        {/* Vision & Mission Section - wider layout */}
        <section className="py-16 bg-gray-50">
          <div className="container mx-auto px-4 md:px-8 lg:px-12">
            <div className="max-w-6xl mx-auto">
              <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
                <div className="bg-white p-8 rounded-lg shadow-md border-t-4 border-blue-600">
                  <h3 className="text-2xl font-bold text-gray-800 mb-4">Our Vision</h3>
                  <p className="text-gray-700 leading-relaxed">
                    To strengthen the Panchayat Raj Institutions (PRIs) through capacity building for sustainable and inclusive rural development in Tamil Nadu.
                  </p>
                </div>
                
                <div className="bg-white p-8 rounded-lg shadow-md border-t-4 border-blue-600">
                  <h3 className="text-2xl font-bold text-gray-800 mb-4">Our Mission</h3>
                  <p className="text-gray-700 leading-relaxed">
                    To develop capable and responsive PRIs through effective training, research, and handholding support, fostering good governance and participatory development.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>
      
      <Footer />
    </div>
  );
};

export default AboutPage;